export default __webpack_public_path__ + "static/media/CertTest.288e494e99146a5e76f7da493f2829ab.webp";